/*=========================================================================================
  File Name: moduleFacilityActions.js
  Description: Facility Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
  AddFacility({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post("api/Facility/AddFacility", item)
        .then((response) => {
          commit('ADD_ITEM', Object.assign(item, { ID: response.data.ID }))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetAllFacilities({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("api/Facility/GetAllFacilities")
        .then((response) => {
          commit('SET_Facilities', response.data.Data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  UpdateFacility({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put("api/Facility/UpdateFacility?ID="+item.ID, item)
        .then((response) => {
          commit('UPDATE_Facility', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetFacility({ commit }, itemid) {
    return new Promise((resolve, reject) => {
      axios.post("api/Facility/GetFacility", itemid)
        .then((response) => {
          commit('UPDATE_Facility', response.data.Data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  DeleteFacility({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.delete("api/Facility/DeleteFacility?ID="+item.ID)
        .then((response) => {
          commit('REMOVE_ITEM', item.ID)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
}
